import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { EEventType } from '../../types/events';
import { EActiveView } from '../../types/view';
import { ERegisterStatus, ERegisterErrorType } from '../../types/registration';
import { ESentEmailType } from '../../types/sentEmail';
import { REGISTRATION_REGISTER_TYPE } from '../../constants/action_types';
import { register as registerApi } from '../../api/register';
import { jsonpRequest } from '../../../browser/utils/jsonpRequest';
import { changeView } from '../view';
import { sendSms } from './sendSms';
import { trackRegistrationSuccess, trackWantsSubscription } from '../../utils/tracking';
export function register(parameters) {
  var email = parameters.email,
      password = parameters.password,
      phone = parameters.phone,
      isProfessional = parameters.isProfessional,
      wantsSubscription = parameters.wantsSubscription;
  return function (dispatch, getState, context) {
    var _getState = getState(),
        agreement = _getState.agreement,
        isNextAgreementFlow = _getState.isNextAgreementFlow;

    dispatch({
      status: ERegisterStatus.Loading,
      type: REGISTRATION_REGISTER_TYPE
    });
    return registerApi(context.httpApi, _objectSpread({
      email: email,
      password: password,
      phone: phone,
      isProfessional: isProfessional
    }, isNextAgreementFlow ? {
      enableSubscription: agreement.marketingSubscriptionAccepted,
      isAcceptLicence: agreement.licenceAccepted
    } : {
      enableSubscription: wantsSubscription,
      isAcceptLicence: true
    })).then(function (response) {
      if (response.statusCode === 200) {
        var _response$response = response.response,
            logOnInfo = _response$response.logOnInfo,
            login = _response$response.login;
        Promise.all(logOnInfo.map(function (info) {
          return jsonpRequest("".concat(info.logOnUrl, "?") + "login=".concat(encodeURIComponent(login), "&") + "token=".concat(info.token, "&") + "persistent=true");
        })).then(function () {
          dispatch({
            status: ERegisterStatus.Succeed,
            type: REGISTRATION_REGISTER_TYPE
          });

          if (phone) {
            dispatch(sendSms({
              email: email,
              phone: phone
            }));
          } else {
            dispatch(changeView(EActiveView.EmailSent, {
              type: ESentEmailType.Registration
            }));
          }

          context.emitter.emit(EEventType.RegisterSucceed, {
            email: email,
            phone: phone,
            isProfessional: isProfessional,
            wantsSubscription: wantsSubscription
          });
          trackRegistrationSuccess('email');

          if (wantsSubscription) {
            trackWantsSubscription();
          }
        }).catch(function () {
          dispatch({
            status: ERegisterStatus.Failed,
            type: REGISTRATION_REGISTER_TYPE,
            errorType: ERegisterErrorType.Common,
            error: 'Произошла непредвиденная ошибка'
          });
        });
        return;
      }

      var errorKey = response.response.errors.length > 0 ? response.response.errors[0].key : null;
      var error = response.response.errors.length > 0 ? response.response.errors[0].message : response.response.message;
      var errorType = ERegisterErrorType.Common;

      switch (errorKey) {
        case 'EmailAlreadyExists':
          errorType = ERegisterErrorType.Email;
          break;

        case 'PasswordError':
          errorType = ERegisterErrorType.Password;
          break;

        case 'ValidaionCodeIsInvalid':
          errorType = ERegisterErrorType.Phone;
          break;
      }

      dispatch({
        status: ERegisterStatus.Failed,
        type: REGISTRATION_REGISTER_TYPE,
        errorType: errorType,
        error: error
      });
    }).catch(function (error) {
      context.logger.error(error);
      dispatch({
        status: ERegisterStatus.Failed,
        type: REGISTRATION_REGISTER_TYPE,
        errorType: ERegisterErrorType.Common,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}